export default __webpack_public_path__ + "static/media/plastic-scm.6bcae62f.svg";